var _effectorFileName = "/src/page-content/speaking-clubs/model.ts";
import { pagesPath } from '@/shared/config/$path';
import { declarePage } from '@/shared/lib/effector/page';
export const speakingClubsPage = declarePage({
  pageType: pagesPath.$url().pathname
});